import _ from 'lodash';
import * as ActionTypes from '../actions/constants';
import { constructTemplate } from '../util';


const initialState = {
  busy: false,
  silhouette: 'Square',
  activeField: null,
  fieldWidthErrors: {},
  invitation: {
    uuid: null,
    cardType: null,
    customizationFields: {},
    orderedFieldsGroupedByPage: [],
    pages: {},
    linerColor: 'none',
    shape: null,
    reversePrintingEnabled: null,
    productOptionValues: {},
  },
  invitationEnvelope: {
    uuid: null,
    cardType: null,
    customizationFields: {},
    orderedFieldsGroupedByPage: [],
    pages: {},
    linerColor: 'none',
    shape: null,
    envelopePrintingEnabled: null,
    returnAddressingEnabled: null,
    productOptionValues: {},
  },
  rsvp: {
    uuid: null,
    cardType: null,
    customizationFields: {},
    orderedFieldsGroupedByPage: [],
    pages: {},
    linerColor: 'none',
    deleted: null,
    shape: null,
    productOptionValues: {},
  },
  rsvpEnvelope: {
    uuid: null,
    cardType: null,
    customizationFields: {},
    orderedFieldsGroupedByPage: [],
    pages: {},
    linerColor: 'none',
    shape: null,
    envelopePrintingEnabled: null,
    productOptionValues: {},
  },
  saveTheDate: {
    uuid: null,
    cardType: null,
    customizationFields: {},
    orderedFieldsGroupedByPage: [],
    pages: {},
    linerColor: 'none',
    shape: null,
    recipientAddressingEnabled: null,
    reversePrintingEnabled: null,
    productOptionValues: {},
  },
  byUUID: {},
  cardTypeToUUID: {},
};


// TODO: refactor to not duplicate logic for different card types - dont worry about right now though
function cardCustomizationsReducer(state = initialState, action = {}) {
  switch (action.type) {
    case ActionTypes.REQUEST_UPDATE_CUSTOMIZATION: {
      return { ...state, busy: true };
    }
    case ActionTypes.RECEIVE_CUSTOMIZATION: {
      const uuid = action.payload.project_customization.uuid;
      const cardType = action.payload.card_type;
      const customizationFields = _.reduce(action.payload.project_customization.fields, (result, field) => {
        result[field.content_key] = { // eslint-disable-line
          body: field.body,
          image_id: field.image_id,
          content_key: field.content_key
        };
        return result;
      }, {});
      const orderedFieldsGroupedByPage = _.map(action.payload.template.pages, (page) => {
        const fields = _.flatMap(page.elements, element => element.fields.map(field => ({ ...field, customizable: element.customizable, linked: element.linked_field_keys })));
        const orderedFields = _.sortBy(fields, field => field.display_order);
        return orderedFields;
      });
      const pages = constructTemplate(action.payload.template);
      const linerColor = action.payload.liner_color;
      const recipientAddressingEnabled = action.payload.project_customization.recipient_addressing;
      const deleted = action.payload.project_customization.deleted;
      const shape = action.payload.project_customization.sku_view.product_option_values.silhouette || null;
      const reversePrintingEnabled = action.payload.project_customization.sku_view.product_option_values['reverse-printing'] !== 'none';
      const envelopePrintingEnabled = action.payload.project_customization.sku_view.product_option_values['envelope-printing'] === 'front';
      const productOptionValues = action.payload.project_customization.sku_view.product_option_values;

      const nextCustomizationProps = {
        uuid,
        cardType,
        customizationFields,
        orderedFieldsGroupedByPage,
        pages,
        linerColor,
        recipientAddressingEnabled,
        deleted,
        shape,
        reversePrintingEnabled,
        envelopePrintingEnabled,
        productOptionValues
      };
      // return {
      //   ...state,
      //   byUUID: {
      //     ...state.byUUID,
      //     [uuid]: {
      //       ...state.byUUID[uuid],
      //       ...nextCustomizationProps
      //     }
      //   }
      // };
      if (action.payload.card_type === 'INVITATION') {
        return {
          ...state,
          busy: false,
          // invitation: {
          //   ...state.invitation,
          //   uuid: action.payload.project_customization.uuid,
          //   cardType: action.payload.card_type,
          //   customizationFields,
          //   orderedFieldsGroupedByPage,
          //   pages,
          //   linerColor: action.payload.liner_color,
          //   shape: action.payload.project_customization.sku_view.product_option_values.silhouette,
          //   reversePrintingEnabled: action.payload.project_customization.sku_view.product_option_values['reverse-printing'] !== 'none',
          //   productOptionValues: action.payload.project_customization.sku_view.product_option_values,
          // },
          invitation: {
            ...state.invitation,
            ...nextCustomizationProps
          },
          byUUID: {
            ...state.byUUID,
            [uuid]: {
              ...state.byUUID[uuid],
              ...nextCustomizationProps
            }
          },
          cardTypeToUUID: {
            ...state.cardTypeToUUID,
            [cardType]: uuid
          }
        };
      } else if (action.payload.card_type === 'RSVP') {
        // const { deleted } = action.payload.project_customization;
        return {
          ...state,
          busy: false,
          // rsvp: {
          //   ...state.rsvp,
          //   uuid: action.payload.project_customization.uuid,
          //   cardType: action.payload.card_type,
          //   customizationFields,
          //   orderedFieldsGroupedByPage,
          //   pages,
          //   linerColor: action.payload.liner_color,
          //   shape: action.payload.project_customization.sku_view.product_option_values.silhouette,
          //   deleted,
          //   productOptionValues: action.payload.project_customization.sku_view.product_option_values,
          // },
          rsvp: {
            ...state.rsvp,
            ...nextCustomizationProps
          },
          byUUID: {
            ...state.byUUID,
            [uuid]: {
              ...state.byUUID[uuid],
              ...nextCustomizationProps
            }
          },
          cardTypeToUUID: {
            ...state.cardTypeToUUID,
            [cardType]: uuid
          }
        };
      } else if (action.payload.card_type === 'INVITATION_ENVELOPE') {
        return {
          ...state,
          busy: false,
          // invitationEnvelope: {
          //   ...state.invitationEnvelope,
          //   uuid: action.payload.project_customization.uuid,
          //   cardType: action.payload.card_type,
          //   customizationFields,
          //   orderedFieldsGroupedByPage,
          //   pages,
          //   linerColor: action.payload.liner_color,
          //   envelopePrintingEnabled: action.payload.project_customization.sku_view.product_option_values['envelope-printing'] === 'front',
          //   recipientAddressingEnabled: action.payload.project_customization.recipient_addressing,
          //   productOptionValues: action.payload.project_customization.sku_view.product_option_values,
          // }
          invitationEnvelope: {
            ...state.invitationEnvelope,
            ...nextCustomizationProps
          },
          byUUID: {
            ...state.byUUID,
            [uuid]: {
              ...state.byUUID[uuid],
              ...nextCustomizationProps
            }
          },
          cardTypeToUUID: {
            ...state.cardTypeToUUID,
            [cardType]: uuid
          }
        };
      } else if (action.payload.card_type === 'RSVP_ENVELOPE') {
        return {
          ...state,
          busy: false,
          // rsvpEnvelope: {
          //   ...state.rsvpEnvelope,
          //   uuid: action.payload.project_customization.uuid,
          //   cardType: action.payload.card_type,
          //   customizationFields,
          //   orderedFieldsGroupedByPage,
          //   pages,
          //   linerColor: action.payload.liner_color,
          //   envelopePrintingEnabled: action.payload.project_customization.sku_view.product_option_values['envelope-printing'] === 'front',
          //   productOptionValues: action.payload.project_customization.sku_view.product_option_values,
          // }
          rsvpEnvelope: {
            ...state.rsvpEnvelope,
            ...nextCustomizationProps
          },
          byUUID: {
            ...state.byUUID,
            [uuid]: {
              ...state.byUUID[uuid],
              ...nextCustomizationProps
            }
          },
          cardTypeToUUID: {
            ...state.cardTypeToUUID,
            [cardType]: uuid
          }
        };
      } else if (action.payload.card_type === 'SAVE_THE_DATE') {
        return {
          ...state,
          busy: false,
          // saveTheDate: {
          //   ...state.saveTheDate,
          //   uuid: action.payload.project_customization.uuid,
          //   cardType: action.payload.card_type,
          //   customizationFields,
          //   orderedFieldsGroupedByPage,
          //   pages,
          //   linerColor: action.payload.liner_color,
          //   shape: action.payload.project_customization.sku_view.product_option_values.silhouette,
          //   reversePrintingEnabled: action.payload.project_customization.sku_view.product_option_values['reverse-printing'] !== 'none',
          //   recipientAddressingEnabled: action.payload.project_customization.recipient_addressing,
          //   productOptionValues: action.payload.project_customization.sku_view.product_option_values,
          // }
          saveTheDate: {
            ...state.saveTheDate,
            ...nextCustomizationProps
          },
          byUUID: {
            ...state.byUUID,
            [uuid]: {
              ...state.byUUID[uuid],
              ...nextCustomizationProps
            }
          },
          cardTypeToUUID: {
            ...state.cardTypeToUUID,
            [cardType]: uuid
          }
        };
      }

      return state;
    }
    case ActionTypes.RECEIVE_RSVP_CARDS_DISABLED: {
      const uuid = state.cardTypeToUUID.RSVP;
      return {
        ...state,
        rsvp: {
          ...state.rsvp,
          deleted: true
        },
        byUUID: {
          ...state.byUUID,
          [uuid]: {
            ...state.byUUID[uuid],
            deleted: true
          }
        }
      };
    }
    case ActionTypes.SET_FOOTER_LABEL: {
      return {
        ...state,
        [action.name]: action.label,
      };
    }
    case ActionTypes.SET_SILHOUETTE: {
      return {
        ...state,
        silhouette: action.label,
      };
    }
    case ActionTypes.SET_ACTIVE_FIELD: {
      const { activeField } = action.payload;
      return { ...state, activeField };
    }
    default:
      return state;
  }
}


export default cardCustomizationsReducer;



/** WEBPACK FOOTER **
 ** ./src/cards/reducers/cardCustomization.js
 **/